export const ANONYMOUS_USER_TEXT = 'Login or create a free account to use the AI Sheet Assistant.';
export const PREVIEW_MODE_TEXT =
  'This sheet is in Preview, so Sheet Assistant is currently locked. For full use of Sheet Assistant, upgrade your account';
